import { useEffect } from "react";

export const SITE_URL = "https://ozentya.org";
const DEFAULT_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/86773c59-3614-477d-9c71-250b0d9699a5/images/027cb154d689c8e5a69429a4e01a191de5cba78df1bff34c3f2b0e81926f4fe3.jpeg";

const setMeta = (selector, attr, value) => {
  if (!value) return;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [key, val] = selector.replace("meta[", "").replace("]", "").split("=");
    el.setAttribute(key, val.replace(/["']/g, ""));
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

const setLink = (rel, href) => {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

// Hook SEO : met à jour title / description / canonical / Open Graph par page.
export const useSeo = ({ title, description, path = "/", image }) => {
  useEffect(() => {
    const url = `${SITE_URL}${path}`;
    const img = image ? (image.startsWith("/") ? `${SITE_URL}${image}` : image) : DEFAULT_IMAGE;
    if (title) document.title = title;
    setMeta('meta[name="description"]', "content", description);
    setLink("canonical", url);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[property="og:image"]', "content", img);
    setMeta('meta[name="twitter:title"]', "content", title);
    setMeta('meta[name="twitter:description"]', "content", description);
    setMeta('meta[name="twitter:image"]', "content", img);
  }, [title, description, path, image]);
};

// Injecte un bloc JSON-LD (données structurées Schema.org) dans le <head>.
export const useJsonLd = (id, data) => {
  useEffect(() => {
    if (!data) return;
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = id;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      const node = document.getElementById(id);
      if (node) node.remove();
    };
  }, [id, data]);
};
